// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file kikoff_canada/protobuf/models/promotions/promotion.proto (package kikoff_canada.protobuf.models.promotions, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { SubscriptionPlan } from "../subscription_plan_pb.js";

/**
 * @generated from message kikoff_canada.protobuf.models.promotions.Promotion
 */
export class Promotion extends Message<Promotion> {
  /**
   * @generated from field: int32 amount = 1;
   */
  amount = 0;

  /**
   * @generated from field: kikoff_canada.protobuf.models.promotions.Promotion.Unit unit = 2;
   */
  unit = Promotion.Unit.UNKNOWN;

  /**
   * @generated from field: int32 months_left = 3;
   */
  monthsLeft = 0;

  /**
   * @generated from field: repeated kikoff_canada.protobuf.models.SubscriptionPlan.Tier valid_tiers = 4;
   */
  validTiers: SubscriptionPlan.Tier[] = [];

  constructor(data?: PartialMessage<Promotion>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.models.promotions.Promotion";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "unit", kind: "enum", T: proto3.getEnumType(Promotion.Unit) },
    { no: 3, name: "months_left", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "valid_tiers", kind: "enum", T: proto3.getEnumType(SubscriptionPlan.Tier), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Promotion {
    return new Promotion().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Promotion {
    return new Promotion().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Promotion {
    return new Promotion().fromJsonString(jsonString, options);
  }

  static equals(a: Promotion | PlainMessage<Promotion> | undefined, b: Promotion | PlainMessage<Promotion> | undefined): boolean {
    return proto3.util.equals(Promotion, a, b);
  }

  static _enums: {
    Unit: typeof Promotion.Unit,
  };
}

export namespace Promotion {
  /**
   * @generated from enum kikoff_canada.protobuf.models.promotions.Promotion.Unit
   */
  export enum Unit {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: CENTS = 1;
     */
    CENTS = 1,

    /**
     * @generated from enum value: PERCENT = 2;
     */
    PERCENT = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(Promotion.Unit)
  proto3.util.setEnumType(Promotion.Unit, "kikoff_canada.protobuf.models.promotions.Promotion.Unit", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "CENTS" },
    { no: 2, name: "PERCENT" },
  ]);
}

